import React, { useState } from 'react';
import { ButtonGroup, Button } from "@nextui-org/react";
import { Link } from 'react-router-dom';
import EconomyView from '../components/EconomyView';
import EducationView from '../components/EducationView';
import LaborView from '../components/LaborView';
import HousingView from '../components/HousingView';
import BizClimateView from '../components/BizClimateView';
import ElectricityView from '../components/ElectricityView';
import Layout from '../components/Layout';

const Dashboard = () => {
  const [activeView, setActiveView] = useState('economy');

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row items-center justify-between mb-6 sm:mb-8">
        <div className="hidden sm:block w-[180px]"></div>
        <h1 className="text-2xl sm:text-3xl font-bold text-center">Opportunity Connecticut Dashboard</h1>
        <Link
          to="/redbook"
          className="mt-2 sm:mt-0 inline-flex items-center px-4 py-2 rounded-lg text-white text-sm font-semibold hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#245BA9' }}
        >
          By the Numbers &rarr;
        </Link>
      </div>
      
      <div className="mb-6 sm:mb-8 flex justify-center">
        {/* For mobile: vertical stack of full-width buttons */}
        <div className="flex flex-col w-full sm:hidden space-y-2 px-4">
          <Button
            color={activeView === 'economy' ? "primary" : "default"}
            onClick={() => setActiveView('economy')}
            className="w-full"
          >
            Economy
          </Button>
          <Button
            color={activeView === 'bizclimate' ? "primary" : "default"}
            onClick={() => setActiveView('bizclimate')}
            className="w-full"
          >
            Business Climate
          </Button>
          <Button
            color={activeView === 'labor' ? "primary" : "default"}
            onClick={() => setActiveView('labor')}
            className="w-full"
          >
            Workforce & Education
          </Button>
          <Button
            color={activeView === 'housing' ? "primary" : "default"}
            onClick={() => setActiveView('housing')}
            className="w-full"
          >
            Housing
          </Button>
          <Button
            color={activeView === 'electricity' ? "primary" : "default"}
            onClick={() => setActiveView('electricity')}
            className="w-full"
          >
            Electricity
          </Button>
        </div>

        {/* For tablet and desktop: horizontal button group */}
        <ButtonGroup className="hidden sm:flex">
          <Button
            color={activeView === 'economy' ? "primary" : "default"}
            onClick={() => setActiveView('economy')}
          >
            Economy
          </Button>
          <Button
            color={activeView === 'bizclimate' ? "primary" : "default"}
            onClick={() => setActiveView('bizclimate')}
          >
            Business Climate
          </Button>
          <Button
            color={activeView === 'labor' ? "primary" : "default"}
            onClick={() => setActiveView('labor')}
          >
            Workforce & Education
          </Button>
          <Button
            color={activeView === 'housing' ? "primary" : "default"}
            onClick={() => setActiveView('housing')}
          >
            Housing
          </Button>
          <Button
            color={activeView === 'electricity' ? "primary" : "default"}
            onClick={() => setActiveView('electricity')}
          >
            Electricity
          </Button>
        </ButtonGroup>
      </div>

      {activeView === 'economy' ? <EconomyView /> :
       activeView === 'bizclimate' ? <BizClimateView /> :
       activeView === 'education' ? <EducationView /> :
       activeView === 'housing' ? <HousingView /> :
       activeView === 'electricity' ? <ElectricityView /> :
       <LaborView />}
    </Layout>
  );
};

export default Dashboard;